<div class="d-lg-block d-none">
  <fgb-banner [title]="'rewards.shipping.page.title' | translate"></fgb-banner>
</div>
<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-member-card-with-wallet-button />
</ng-container>

<div class="container">
  <div class="card rounded d-flex align-items-center justify-content-center">
    <p
      class="font-size-14 mb-0 reward-shipping-instruction"
      [innerHTML]="'rewards.shipping.page.card.text' | translate | markdownTranslate"
    ></p>
  </div>
  <div class="reward-shipping-form rounded">
    <h5 class="mx-2 text-primary">{{ 'reward.shipping.page.form.title' | translate }}</h5>
    <fgbcl-model-meta-data-form
      [formGroup]="shippingForm"
      [models]="models"
      [wscPrefix]="'rewards.shipping'"
    ></fgbcl-model-meta-data-form>
    <div class="submit-message d-flex justify-content-center">
      @if (isSuccess) {
      <p class="text-success pb-3 font-size-14">{{ 'rewards.shipping.page.form.success.message' | translate }}</p>
      }@else if(isError) {
      <p class="text-danger pb-3 font-size-14">{{ 'rewards.shipping.page.form.error.message' | translate }}</p>
      }
    </div>
    <button class="btn btn-success submit-btn fw-bold mx-auto" (click)="submit()">
      {{ 'rewards.shipping.page.form.submit' | translate }}
    </button>
  </div>
</div>
